import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    email: '',
    isAuthenticated: false,
    userId: '',
    firstName: '',
    lastName: '',
  }),
  persist: true,
  actions: {
    getFullName() {
      if (!this.firstName && !this.lastName) {
        return ''
      }

      let name = ''
      if (this.firstName) {
        name += this.firstName
      }
      if (this.lastName) {
        name += ` ${this.lastName}`
      }

      return name
    },
    setEmail(email) {
      this.email = email
    },
    setUser(isAuthenticated, email, userId, firstName, lastName) {
      this.isAuthenticated = isAuthenticated
      this.email = email
      this.userId = userId
      this.firstName = firstName
      this.lastName = lastName
    },
  },
})
